export default __webpack_public_path__ + "static/media/cover.6b9bebfd.svg";